import authAxios from '@services/authAxios';

const fetchConfigurationInfo = async (id) => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/configuration/${id}`,
    });

    return data?.data;
};

export default fetchConfigurationInfo;
